import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class ProjectBuildsService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Get project builds
     * @returns any OK.
     * @throws ApiError
     */
    listProjectBuilds({ orgId, projectId, after, before, sort = '-id', filter, search, limit = 10, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/builds', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'sort': sort,
                'filter': filter,
                'search': search,
                'limit': limit,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Create project build
     * @returns ProjectBuildDetailedResponse New project build created.
     * @throws ApiError
     */
    createProjectBuild({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/builds', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get branches from preview project builds
     * @returns any OK.
     * @throws ApiError
     */
    getPreviewBranches({ orgId, projectId, after, before, sort = '-id', filter, search, limit = 10, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/preview-branches', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'sort': sort,
                'filter': filter,
                'search': search,
                'limit': limit,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update project build
     * @returns ProjectBuild OK.
     * @throws ApiError
     */
    updateProjectBuild({ orgId, projectId, buildId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/projects/{projectId}/builds/{buildId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'buildId': buildId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get project build
     * @returns ProjectBuildDetailedResponse OK.
     * @throws ApiError
     */
    getProjectBuild({ orgId, projectId, buildId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/builds/{buildId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'buildId': buildId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Publish project build
     * @returns any OK.
     * @throws ApiError
     */
    publishProjectBuild({ orgId, projectId, buildId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/builds/{buildId}/publish', path: {
                'orgId': orgId,
                'projectId': projectId,
                'buildId': buildId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Create project build logs
     * @returns void
     * @throws ApiError
     */
    createProjectBuildLogsBatch({ orgId, projectId, buildId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/builds/{buildId}/logs/batch', path: {
                'orgId': orgId,
                'projectId': projectId,
                'buildId': buildId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Restart project build
     * @returns ProjectBuildDetailedResponse New project build created.
     * @throws ApiError
     */
    restartProjectBuild({ orgId, projectId, buildId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/builds/{buildId}/restart', path: {
                'orgId': orgId,
                'projectId': projectId,
                'buildId': buildId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update project build total pages
     * @returns Pages OK.
     * @throws ApiError
     */
    updateProjectBuildTotalPages({ orgId, projectId, buildId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/projects/{projectId}/builds/{buildId}/pages', path: {
                'orgId': orgId,
                'projectId': projectId,
                'buildId': buildId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=ProjectBuildsService.js.map